"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = getErrorMessage;
exports.getVerificationMessage = getVerificationMessage;
const ttag_1 = require("ttag");
const crypto_1 = require("../crypto");
function getErrorMessage(error) {
    return error instanceof Error ? error.message : (0, ttag_1.c)('Error').t `Unknown error`;
}
/**
 * @param signatureType - Must be translated before calling this function.
 */
function getVerificationMessage(verified, verificationErrors, signatureType, notAvailableVerificationKeys = false) {
    if (verified === crypto_1.VERIFICATION_STATUS.NOT_SIGNED) {
        return signatureType ? (0, ttag_1.c)('Error').t `Missing signature for ${signatureType}` : (0, ttag_1.c)('Error').t `Missing signature`;
    }
    if (notAvailableVerificationKeys) {
        return signatureType
            ? (0, ttag_1.c)('Error').t `Verification keys for ${signatureType} are not available`
            : (0, ttag_1.c)('Error').t `Verification keys are not available`;
    }
    if (verificationErrors) {
        const errorMessage = verificationErrors?.map((e) => e.message).join(', ');
        return signatureType
            ? (0, ttag_1.c)('Error').t `Signature verification for ${signatureType} failed: ${errorMessage}`
            : (0, ttag_1.c)('Error').t `Signature verification failed: ${errorMessage}`;
    }
    return signatureType
        ? (0, ttag_1.c)('Error').t `Signature verification for ${signatureType} failed`
        : (0, ttag_1.c)('Error').t `Signature verification failed`;
}
//# sourceMappingURL=errors.js.map